//@formatter:off
/**
 * @ngdoc filter
 * @name comma2decimal
 * @module portaro.filters
 * @kind function
 *
 * @param {string|number} input Input
 *
 * @return {number} Parsed number
 *
 * @description
 * Filter converts input to float number. Doesn't matter if input is `string` or decimal separator is `,`.
 *
 * @example
 * <example module="comma2decimalFilterExample" name="comma2decimalFilterExample" frame-no-resize="true">
    <file name="index.html">
        <main>
            <div>
                <label for="input">Input value: </label>
                <input id="input" type="text" ng-model="input">
            </div>
            <div>
                Output: {{input | comma2decimal}}
            </div>
        </main>
    </file>
    <file name="script.js">
        angular.module('comma2decimalFilterExample', ['portaro.filters']);
    </file>
 * </example>
 */
 //@formatter:on
export default function comma2decimalFilter() {
    return (input) => {
        const ret = input || input === 0 ? input.toString().trim().replace(',', '.') : null;
        return parseFloat(ret);
    };
}

comma2decimalFilter.filterName = 'comma2decimal';